import { AdventureMode } from "../types/enum";

export const arenaModes : Record<AdventureMode,string> = {
    [AdventureMode.Solo]: "Solo",
    [AdventureMode.PrivateRaid]: "Private Raid",
    [AdventureMode.GuildRaid]: "Guild Raid",
    [AdventureMode.PublicRaid]: "Public Raid",
    [AdventureMode.ArenaFriendlyMatch]: "Friendly Match",
    [AdventureMode.ArenaFree100kNoEnergy]: "Free 100k (No Energy)",
    [AdventureMode.ArenaFree100k]: "Free to play 100k",
    [AdventureMode.ArenaFree300k]: "Free 300k",
    [AdventureMode.ArenaFree900k]: "Free 900k",
    [AdventureMode.ArenaFree2700k]: "Free 2700k",
    [AdventureMode.ArenaFree8100k]: "Free 8100k",
    [AdventureMode.Arena100k]: "100k",
    [AdventureMode.Arena300k]: "300k",
    [AdventureMode.Arena900k]: "900k",
    [AdventureMode.Arena2700k]: "2700k",
    [AdventureMode.Arena8100k]: "8100k",
}

export const arenaModesIcons : Record<string,string> = {
    [AdventureMode.ArenaFriendlyMatch]: "/assets/images/arena/icons/modes/friendly.png",
    [AdventureMode.ArenaFree100kNoEnergy]:"/assets/images/arena/icons/modes/free-army.png",
    [AdventureMode.ArenaFree100k]:"/assets/images/arena/icons/modes/free-army.png",
    [AdventureMode.ArenaFree300k]:"/assets/images/arena/icons/modes/free-army.png",
    [AdventureMode.ArenaFree900k]:"/assets/images/arena/icons/modes/free-army.png",
    [AdventureMode.ArenaFree2700k]:"/assets/images/arena/icons/modes/free-army.png",
    [AdventureMode.ArenaFree8100k]:"/assets/images/arena/icons/modes/8100.png",
    [AdventureMode.Arena100k]: "/assets/images/arena/icons/modes/100k.png",
    [AdventureMode.Arena300k]: "/assets/images/arena/icons/modes/300k.png",
    [AdventureMode.Arena900k]: "/assets/images/arena/icons/modes/900k.png",
    [AdventureMode.Arena2700k]: "/assets/images/arena/icons/modes/2700.png",
    [AdventureMode.Arena8100k]: "/assets/images/arena/icons/modes/8100.png",
}
